import { render, staticRenderFns } from "./edit-jackpot.vue?vue&type=template&id=1ceba88c&"
import script from "./edit-jackpot.vue?vue&type=script&lang=js&"
export * from "./edit-jackpot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports